module.exports = __webpack_public_path__ + "img/Morris.37872494.jpg";